export default "__VITE_ASSET__ca5061af__"